export default "__VITE_ASSET__Dl9XN$hK__"